import React, { Component } from 'react';
import { observer } from 'mobx-react';
import NormTreeTableContainer from './NormTreeTableContainer';
import store from './_store';

class NormTreeTable extends Component {

  render() {
    return <NormTreeTableContainer store={store} />
  }
}

export default observer(NormTreeTable);